module.exports = {
      id: "authoranchor-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#authoranchor",
      toString: function () {
        return this.url;
      }
    }